import React, { useEffect, useState } from "react";
import ReactDataGrid from "react-data-grid";
import { Container, Button, Modal, Dropdown, Grid, Pagination, Icon, Confirm, Input, Table, Segment, Dimmer, Loader } from 'semantic-ui-react'
import _ from "lodash";
import moment from 'moment'
import { toast } from 'react-toastify';
import { useSelector, useDispatch } from 'react-redux';
import { getShift } from '../../Redux/Actions/ShiftAction'
import { getDutyRosterShow, saveDutyRoster } from '../../Redux/Actions/DutyRosterAction'
import AppLoader from '../../Components/AppLoader';

const DutyRosterUpdate = ({ history }) => {

   const authToken = localStorage.getItem('accessToken');
   const dispatch = useDispatch()

   useEffect(() => {
      dispatch(getShift(toast, authToken))
      dispatch(getDutyRosterShow(toast, authToken, setDutyRosterShowData))
   }, [])

   // const dutyRosterShowData1 = useSelector(state => state.dutyRosterReducer.dutyRosterShowPayload)
   const isLoading = useSelector(state => state.loadingReducer.loadingPayload)
   const [shift, setShift] = useState('')
   const [shiftYear, setShiftYear] = useState(moment().format('YYYY'))
   const [shiftMonth, setShiftMonth] = useState(JSON.parse(moment().add(1, 'M').format("M")))
   const [dutyRosterShowData, setDutyRosterShowData] = useState([])
   const [searchInput, setSearchInput] = React.useState('');
   const shiftData = useSelector(state => state.shiftReducer.shiftPayload)
   const shiftList = shiftData && shiftData.filter(item => item.status === 'A').map((data, index) => {
      return {
         key: index,
         value: data.id,
         text: data.name,
      }
   })

   const yearOptions = [
      { key: moment().add(-1, 'y').format('YYYY'), value: moment().add(-1, 'y').format('YYYY'), text: moment().add(-1, 'y').format('YYYY') },
      { key: moment().format('YYYY'), value: moment().format('YYYY'), text: moment().format('YYYY') },
      { key: moment().add(1, 'y').format('YYYY'), value: moment().add(1, 'y').format('YYYY'), text: moment().add(1, 'y').format('YYYY') },
   ]

   const monthOptions = moment.months().map((item, index) => {
      return {
         key: index,
         value: index + 1,
         text: item
      }
   })

   const dateforNumber = moment(`${shiftYear}-${shiftMonth}`, "YYYY-MM").daysInMonth();
   const monthDays = []
   _.times(dateforNumber, (i) => { monthDays.push(i + 1) })

   const columns = [
      { key: "id", name: "ID", frozen: true, width: 50 },
      { key: "title", name: "Post Name", frozen: true, width: 150 },
   ];

   const monthDateArrey = monthDays.map(item => {
      return {
         key: `day_${item}`,
         name: `Day${item}`,
         editable: true
      }
   })

   const columnData = [...columns, ...monthDateArrey]

   const [postAgainstShift, setPostAgainstShift] = useState({ rows: [] })

   const onGridRowsUpdated = ({ fromRow, toRow, updated }) => {
      setPostAgainstShift(data => {
         const rows = data.rows.slice();
         for (let i = fromRow; i <= toRow; i++) {
            rows[i] = { ...rows[i], ...updated };
         }
         return { rows };
      });
   };

   const handleShiftSelect = (shiftId, month) => {
      // console.log(shiftId, month);
      const shiftPost = dutyRosterShowData && dutyRosterShowData
         .filter(item => item.shift_id === shiftId)
         .filter(item => item.month === month)

      setPostAgainstShift({
         rows: shiftPost.map((item, index) => {
            return {
               id: item.id,
               title: item.post.name,
               shiftId: shift,
               day_1: item.day_1,
               day_2: item.day_2,
               day_3: item.day_3,
               day_4: item.day_4,
               day_5: item.day_5,
               day_5: item.day_5,
               day_6: item.day_6,
               day_7: item.day_7,
               day_8: item.day_8,
               day_9: item.day_9,
               day_10: item.day_10,
               day_11: item.day_11,
               day_12: item.day_12,
               day_13: item.day_13,
               day_14: item.day_14,
               day_15: item.day_15,
               day_16: item.day_16,
               day_17: item.day_17,
               day_18: item.day_18,
               day_19: item.day_19,
               day_20: item.day_20,
               day_21: item.day_21,
               day_22: item.day_22,
               day_23: item.day_23,
               day_24: item.day_24,
               day_25: item.day_25,
               day_26: item.day_26,
               day_27: item.day_27,
               day_28: item.day_28,
               day_29: item.day_29,
               day_30: item.day_30,
               day_31: item.day_31,
               shiftMonth: month,
            }
         })
      })
      // console.log(shiftPost);
   }

   const handleSubmit = () => {
      // console.log(postAgainstShift)
      dispatch(saveDutyRoster(postAgainstShift, toast, authToken))
   }


   return (
      <Container fluid>
         <Grid>
            <Grid.Column floated='left' width={8}>
               <h2 style={{ fontSize: 22, color: 'rgba(0,0,0,0.87)', fontWeight: 400 }}>Shift Management</h2>
            </Grid.Column>
            <Grid.Column floated='right' width={8}>
               <Button
                  floated='right'
                  positive
                  onClick={handleSubmit}>
                  <Icon name='save outline' />
                  Save Record
               </Button>
               <Button
                  floated='right'
                  primary
                  onClick={() => history.push('duty-roster')}>
                  <Icon name='reply' />
                  Back
               </Button>
            </Grid.Column>
         </Grid>
         <Grid className="table-action-header">
            <Grid.Column floated='left' width={10}>
               <Grid>
                  <Grid.Column floated='left'>
                     <Dropdown
                        placeholder='Year'
                        selection
                        search
                        options={yearOptions}
                        defaultValue={shiftYear}
                        onChange={(e, { value }) => (
                           setShiftYear(value),
                           handleShiftSelect(shift, moment(`${value}-${shiftMonth}`).format('YYYY-MM'))
                        )}
                     />
                  </Grid.Column>
                  <Grid.Column floated='left'>
                     <Dropdown
                        placeholder='Month'
                        selection
                        search
                        options={monthOptions}
                        defaultValue={shiftMonth}
                        onChange={(e, { value }) => (
                           setShiftMonth(value),
                           handleShiftSelect(shift, moment(`${shiftYear}-${value}`).format('YYYY-MM'))
                        )}
                     />
                  </Grid.Column>
                  <Grid.Column floated='left'>
                     <Dropdown
                        placeholder='Shift'
                        selection
                        search
                        options={shiftList}
                        value={shift}
                        defaultValue={shift}
                        onChange={(e, { value }) => (
                           console.log(value),
                           setShift(value),
                           handleShiftSelect(value, moment(`${shiftYear}-${shiftMonth}`).format('YYYY-MM'))
                        )}
                     />
                  </Grid.Column>
               </Grid>
            </Grid.Column>
            <Grid.Column floated='right' width={6}>
               <Input style={{ float: 'right' }}
                  icon='search'
                  placeholder='Search..'
                  value={searchInput}
                  onChange={e => setSearchInput(e.target.value)}
               />
            </Grid.Column>
         </Grid>
         {isLoading && isLoading.status ? <AppLoader /> :
            <ReactDataGrid
               columns={columnData}
               rowGetter={i => postAgainstShift.rows[i]}
               rowsCount={postAgainstShift.rows.length}
               onGridRowsUpdated={onGridRowsUpdated}
               enableCellSelect={true}
            />}
      </Container>
   );
}

export default DutyRosterUpdate